import { HealthCheck } from 'src/core/components/app/healthCheck'
import { Registration } from 'src/core/components/app/RegistrationForm'
import { IRouteData } from 'src/core/routes/types'

export const DEFAULT_CUSTOM_ROUTES: IRouteData[] = [
  {
    path: '/health_check',
    access: 'Common',
    element: <HealthCheck />,
  },
  {
    path: '/registration',
    access: 'Guest',
    element: <Registration />,
  },
]
